var map = {
	"./Press/alana1.png": 6045,
	"./Press/alana2.png": 614,
	"./Press/alanatn.png": 3889,
	"./Press/angus1.png": 2890,
	"./Press/angus2.png": 4331,
	"./Press/angus3.jpg": 8731,
	"./Press/angus4.jpg": 7352,
	"./Press/angustn.png": 8072,
	"./Press/april1.png": 5289,
	"./Press/april2.png": 2144,
	"./Press/april3.png": 4528,
	"./Press/april4.png": 128,
	"./Press/apriltn.png": 200,
	"./Press/beverly1.png": 259,
	"./Press/beverly2.png": 8301,
	"./Press/beverly3.png": 9631,
	"./Press/beverly4.png": 6008,
	"./Press/beverlytn.png": 1714,
	"./Press/charles1.jpg": 2823,
	"./Press/charles2.jpg": 6805,
	"./Press/charles3.jpg": 8487,
	"./Press/charlestn.jpg": 2095,
	"./Press/deniz1.jpg": 8624,
	"./Press/deniz2.jpg": 7537,
	"./Press/deniz3.jpg": 6305,
	"./Press/deniztn.jpg": 8218,
	"./Press/ella1.png": 4116,
	"./Press/ella2.png": 6957,
	"./Press/ella3.png": 7798,
	"./Press/ella4.png": 1098,
	"./Press/ellatn.png": 9018,
	"./Press/emili1.png": 2582,
	"./Press/emili2.png": 2129,
	"./Press/emili3.png": 8016,
	"./Press/emili4.png": 3546,
	"./Press/emili5.png": 6829,
	"./Press/emilitn.png": 7007,
	"./Press/finn.jpg": 2310,
	"./Press/finn2.jpeg": 1582,
	"./Press/finntn.jpg": 5800,
	"./Press/jasmine1.png": 3355,
	"./Press/jasmine2.png": 3116,
	"./Press/jasmine3.png": 9805,
	"./Press/jasmine4.png": 1235,
	"./Press/jasmine5.png": 6565,
	"./Press/jasminetn.png": 1599,
	"./Press/jazelle1.png": 1431,
	"./Press/jazelle2.png": 7662,
	"./Press/jazelle3.png": 5818,
	"./Press/jazelle4.png": 8255,
	"./Press/jazelle5.png": 2246,
	"./Press/jazelletn.png": 7139,
	"./Press/juliette1.png": 622,
	"./Press/juliette2.png": 5809,
	"./Press/juliettetn.png": 5376,
	"./Press/katya1.jpg": 4135,
	"./Press/katya2.jpg": 7845,
	"./Press/katya3.jpg": 4109,
	"./Press/katya4.jpg": 1204,
	"./Press/katyatn.jpg": 8337,
	"./Press/liyeng1.jpg": 9942,
	"./Press/liyeng2.png": 4011,
	"./Press/liyeng3.png": 5958,
	"./Press/liyeng4.png": 9499,
	"./Press/liyeng5.jpg": 3286,
	"./Press/liyengtn.jpg": 5997,
	"./Press/nicholas1.jpg": 4634,
	"./Press/nicholas2.jpg": 9643,
	"./Press/nicholas3.jpg": 4107,
	"./Press/nicholas4.jpg": 2034,
	"./Press/nicholas5.jpeg": 5698,
	"./Press/nicholastn.jpg": 9431,
	"./Press/paul1.jpg": 7065,
	"./Press/paul2.jpg": 7614,
	"./Press/paultn.jpg": 4491,
	"./Press/placeholder.png": 7523,
	"./Press/quan1.jpg": 8699,
	"./Press/quan2.png": 5681,
	"./Press/quan3.png": 6472,
	"./Press/quan4.png": 6947,
	"./Press/quantn.jpg": 1722,
	"./Press/raquel.png": 8827,
	"./Press/raquel1.png": 4267,
	"./Press/raquel2.png": 4640,
	"./Press/raquel3.png": 4182,
	"./Press/raquel4.png": 8015,
	"./Press/raquel5.png": 710,
	"./Press/raqueltn.png": 9593,
	"./Press/rionna1.jpg": 4317,
	"./Press/rionna2.png": 7125,
	"./Press/rionna3.png": 8225,
	"./Press/rionna4.png": 276,
	"./Press/rionna5.png": 7228,
	"./Press/rionnatn.jpg": 1449,
	"./Press/rmitlogo.png": 245,
	"./Press/rongshen1.png": 1533,
	"./Press/rongshen2.png": 5940,
	"./Press/rongshen3.png": 7928,
	"./Press/rongshentn.png": 7205,
	"./Press/sophie1.jpg": 3666,
	"./Press/sophie2.jpg": 2837,
	"./Press/sophie3.png": 9618,
	"./Press/sophietn.jpg": 9087,
	"./Press/sum1.png": 2234,
	"./Press/sum2.png": 8207,
	"./Press/sum3.png": 9010,
	"./Press/sum4.png": 6129,
	"./Press/sum5.png": 9115,
	"./Press/sumtn.png": 426,
	"./Press/teresa1.jpg": 1051,
	"./Press/teresa2.jpg": 3506,
	"./Press/teresa3.jpg": 514,
	"./Press/teresa4.jpg": 4500,
	"./Press/teresatn.jpg": 3594,
	"./Press/william1.png": 879,
	"./Press/william2.png": 5420,
	"./Press/william3.png": 5804,
	"./Press/william4.png": 1398,
	"./Press/william5.png": 3551,
	"./Press/williamtn.png": 750,
	"./Press/xiaohui1.png": 7642,
	"./Press/xiaohui2.png": 2604,
	"./Press/xiaohui3.png": 3791,
	"./Press/xiaohuitn.png": 6394,
	"./Press/xinyuan1.png": 6504,
	"./Press/xinyuan2.png": 7637,
	"./Press/xinyuan3.png": 5250,
	"./Press/xinyuan4.png": 3032,
	"./Press/xinyuantn.png": 9281,
	"./Press/xiu1.png": 9434,
	"./Press/xiu2.png": 8951,
	"./Press/xiu3.png": 1611,
	"./Press/xiu4.png": 1468,
	"./Press/xiu5.png": 6661,
	"./Press/xiutn.png": 7305,
	"./Press/yidi1.jpg": 1169,
	"./Press/yidi2.jpg": 953,
	"./Press/yidi3.jpg": 1329,
	"./Press/yiditn.jpg": 1341,
	"./Press/yixuan1.jpg": 186,
	"./Press/yixuan2.jpg": 5216,
	"./Press/yixuan3.jpg": 7791,
	"./Press/yixuan4.jpg": 3230,
	"./Press/yixuantn.jpg": 381,
	"./Press/yuchen1.jpg": 1352,
	"./Press/yuchen2.jpg": 9256,
	"./Press/yuchen3.jpg": 2648,
	"./Press/yuchentn.jpg": 9410,
	"./Press/zixin1.jpg": 8572,
	"./Press/zixin2.jpg": 2757,
	"./Press/zixin3.jpg": 3328,
	"./Press/zixin4.jpg": 8568,
	"./Press/zixin5.jpg": 7356,
	"./Press/zixintn.jpg": 4862,
	"./Press/ziyu1.jpg": 3242,
	"./Press/ziyu2.jpg": 5556,
	"./Press/ziyu3.jpg": 3988,
	"./Press/ziyutn.jpg": 6281,
	"./Random/1.png": 4299,
	"./Random/10.png": 7677,
	"./Random/11.png": 6338,
	"./Random/12.png": 5645,
	"./Random/13.png": 8774,
	"./Random/14.png": 5208,
	"./Random/15.png": 1030,
	"./Random/16.png": 5106,
	"./Random/17.png": 4002,
	"./Random/18.png": 1763,
	"./Random/19.png": 4217,
	"./Random/2.png": 9207,
	"./Random/3.png": 8019,
	"./Random/4.png": 8920,
	"./Random/5.png": 9723,
	"./Random/6.png": 6647,
	"./Random/7.png": 2917,
	"./Random/8.png": 8286,
	"./Random/9.png": 516,
	"./Random/instructions.png": 6494,
	"./Random/sys.PUFFINS.png": 9376,
	"./SquareCursor.cur": 2897,
	"./SquareCursor.png": 6380,
	"./SquareCursor.svg": 7982,
	"./SquareMask.png": 3902,
	"./StarMask.png": 8384,
	"./StarMask.svg": 5065,
	"./icon.png": 4211,
	"./test-paper-texture-2.png": 8736,
	"./test-paper-texture-3.png": 332,
	"./test-paper-texture-4.png": 4241,
	"./test-paper-texture-5.png": 3781,
	"./test-paper-texture-6.png": 5851,
	"./test-paper-texture.png": 9098
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3526;